"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanelMenuItemsMobile = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var dropdown_menu_1 = require("../../../dropdown-menu/dropdown-menu");
function TabPanelMenuItemsMobile(props) {
    var tabs = props.tabs, _a = props.activeIndex, activeIndex = _a === void 0 ? 0 : _a, onTabClick = props.onTabClick;
    var firstTab = tabs[0], secondTab = tabs[1], restTabs = tabs.slice(2);
    var firstTabs = [];
    if (firstTab) {
        firstTabs.push(firstTab);
    }
    if (secondTab) {
        firstTabs.push(secondTab);
    }
    var getItemClassName = function (index) {
        return ['components-tab-panel__tabs-item', index === activeIndex ? 'is-active' : ''].join(' ');
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "components-tab-panel__tabs show-on-mobile", children: [firstTabs.map(function (tab, index) {
                var title = tab.title, icon = tab.icon, onClick = tab.onClick;
                return ((0, jsx_runtime_1.jsx)("div", { className: getItemClassName(index), onClick: function () {
                        onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(index);
                        onClick === null || onClick === void 0 ? void 0 : onClick();
                    }, children: (0, jsx_runtime_1.jsxs)("span", { children: [icon !== null && icon !== void 0 ? icon : null, " ", title] }) }, index));
            }), (0, jsx_runtime_1.jsx)("div", { className: getItemClassName(-1), children: (0, jsx_runtime_1.jsx)(dropdown_menu_1.DropdownMenu, { label: "More Items", text: "More Items", controls: restTabs.map(function (item, index) {
                        var _a = item.title, title = _a === void 0 ? '' : _a;
                        return {
                            title: title,
                            isActive: activeIndex === index + 2,
                            onClick: function () {
                                var _a;
                                onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(index + 2);
                                (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
                            }
                        };
                    }) }) })] }));
}
exports.TabPanelMenuItemsMobile = TabPanelMenuItemsMobile;
